module.exports = __webpack_public_path__ + "img/15.2d5b1715.png";